import { barColors } from 'features/Engagement/engagementConstants'
import { useEffect, useState } from 'react'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, YAxis } from 'recharts'
import engagementApi from 'services/api/engagement'

import styles from './MessagesByCategory.module.scss'

const MessagesByCategory = ({ startDate, endDate, hotelIds }) => {
  const [categoryData, setCategoryData] = useState()
  const [categoryDataStatus, setCategoryStatus] = useState('pending')
  const [categoryDataError, setCategoryDataError] = useState()

  useEffect(() => {
    setCategoryStatus('pending')

    const abortController = new AbortController()

    engagementApi
      .kinds(
        {
          subsidiaryIds: hotelIds,
          fromDate: startDate.format('YYYY-MM-DD'),
          toDate: endDate.format('YYYY-MM-DD')
        },
        abortController
      )
      .then(data => {
        setCategoryData(data)
        setCategoryStatus('fetched')
      })
      .catch(err => {
        if (!err.toString().includes('The user aborted a request.')) {
          setCategoryStatus('rejected')
          setCategoryDataError(err)
        }
      })

    return () => abortController.abort()
  }, [hotelIds, startDate, endDate])

  if (categoryDataStatus === 'pending') {
    return <div className={styles.wrapper}></div>
  }

  if (categoryDataStatus === 'rejected') {
    return (
      <div className={styles.wrapper}>
        Failed to get data: {categoryDataError?.toString()}
      </div>
    )
  }

  const chartData = [
    Object.values(categoryData).reduce(
      (prev, curr) => ({ ...prev, [curr.kind]: curr.kindCount }),
      {}
    )
  ]

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>Received messages by category</h3>
      <div className={styles.graphHolder}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width="100%"
            height={200}
            data={chartData}
            margin={{
              top: 0,
              right: 30,
              left: 0,
              bottom: 15
            }}
            barGap={20}
          >
            <CartesianGrid stroke="#F2F2F2" vertical={false} />
            <YAxis
              tickSize={0}
              axisLine={false}
              width={55}
              tick={{
                fill: '#7D7D7D',
                fontSize: 12
              }}
              tickFormatter={x => `${x}`}
              padding={{ top: 40, bottom: 0 }}
            />
            <Bar dataKey="Service" fill={barColors[0]} barSize={32} />
            <Bar dataKey="Sales" fill={barColors[1]} barSize={32} />
            <Bar dataKey="Review" fill={barColors[2]} barSize={32} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className={styles.legends}>
        <div className={styles.legendRow}>
          <svg width={14} height={14}>
            <rect width={14} height={14} fill={barColors[0]} />
          </svg>
          <span className={styles.legendLabel}>During stay</span>
          <span className={styles.legendValue}>{categoryData.Service.kindCount}</span>
        </div>
        <div className={styles.legendRow}>
          <svg width={14} height={14}>
            <rect width={14} height={14} fill={barColors[1]} />
          </svg>
          <span className={styles.legendLabel}>Before stay</span>
          <span className={styles.legendValue}>{categoryData.Sales.kindCount}</span>
        </div>
        <div className={styles.legendRow}>
          <svg width={14} height={14}>
            <rect width={14} height={14} fill={barColors[2]} />
          </svg>
          <span className={styles.legendLabel}>Review</span>
          <span className={styles.legendValue}>{categoryData.Review.kindCount}</span>
        </div>
      </div>
    </div>
  )
}

export default MessagesByCategory
